import { RangeField } from "@/modules/Dashboards/AdminDashboard/models/RangeField";
import { SecondaryFilter } from "@/modules/Dashboards/AdminDashboard/models/SecondaryFilter";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { EVENT_EMITTER } from "../../constants/GenericSearchConstants";
import { ObjFilterList } from "../../model/List";

@Component({
  name: "FilterTypeShemaRange"
})
export default class FilterTypeShemaRange extends Vue {
  @Prop({ default: () => false }) isPrincipal!: boolean;
  @Prop() itemFilter!: SecondaryFilter;
  @Prop() private selectFilter!: ObjFilterList[];
  @Prop({ default: () => [] }) ItemsShemaRange!: RangeField[];

  clearData = 0;

  beforeMount() {
    this.initFilter();
    this.callData();
  }

  @Watch("selectFilter")
  @Watch("ItemsShemaRange")
  initFilter() {
    this.ItemsShemaRange?.forEach(ItemShemaRange => {
      const selectFilter = this.selectFilterLocal?.find(
        filter => filter.key == ItemShemaRange.key
      );
      if (!selectFilter) {
        ItemShemaRange.selected = false;
        return;
      }
      ItemShemaRange.selected = true;
      ItemShemaRange.value = selectFilter.operation as number[];
    });
    this.reload();
  }

  reload() {
    this.clearData = 1 - this.clearData;
  }

  callData() {
    this.$emit(EVENT_EMITTER.CALL_DATA, this.itemFilter);
  }

  get selectFilterLocal() {
    return this.selectFilter;
  }

  set selectFilterLocal(filterSelected: ObjFilterList[]) {
    this.$emit(EVENT_EMITTER.UPDATE_SELECT_FILTER, filterSelected);
  }

  listLabels(list: number[]) {
    const max = Math.max(...list);
    const min = Math.min(...list);
    const length = max - min + 1;
    const labels = Array.from({ length }, (_, i) => i + min);
    return labels;
  }

  selectFilterUpdate() {
    const selectFilter: ObjFilterList[] = [];
    this.ItemsShemaRange?.forEach(ItemShemaRange => {
      if (!ItemShemaRange.selected) {
        return;
      }
      selectFilter.push({
        key: ItemShemaRange.key,
        name:
          ItemShemaRange.title +
          " de " +
          ItemShemaRange.value[0] +
          " a " +
          ItemShemaRange.value[1],
        operation: ItemShemaRange.value
      });
    });
    const compare =
      JSON.stringify(selectFilter) === JSON.stringify(this.selectFilterLocal);
    if (!compare) {
      this.selectFilterLocal = selectFilter;
    }
  }
}
